import { Button } from 'semantic-ui-react';
import GuestPlainData from 'src/components/helpers/guests/GuestPlainData';
import { hasFormErrors } from 'src/containers/comunidad-network/form/networkFormUtils';

const OwnerSection = ({ children }) => (
  <section className="form-section">
    <h3 className="form-section__title">Información del propietario</h3>
    <div className="form-section__body">{children}</div>
  </section>
);

export const NetworkFormCreateOwner = ({
  inputs,
  errorInputs,
  lookingUp,
  sending,
  onGuestUpdated,
  onChangeIdentity,
}) => (
  <OwnerSection>
    <div style={{ marginBottom: '1rem' }}>
      <Button
        type="button"
        secondary
        size="mini"
        disabled={lookingUp || sending}
        onClick={onChangeIdentity}
      >
        Cambiar cédula / celular
      </Button>
    </div>
    <GuestPlainData
      guest={inputs}
      onGuestUpdated={onGuestUpdated}
      highlightEdit={hasFormErrors(errorInputs)}
    />
  </OwnerSection>
);

const discipleProfilePath = ({ identification, phone } = {}) => {
  const params = new URLSearchParams();
  if (identification) params.set('identification', String(identification));
  if (phone) params.set('phone', String(phone));
  return `/perfil/crecer?${params.toString()}`;
};

export const NetworkFormEditOwner = ({ guest = {}, onGuestUpdated }) => (
  <OwnerSection>
    {guest.identification && (
      <div style={{ marginBottom: '1rem' }}>
        <a href={discipleProfilePath(guest)} target="_blank" rel="noreferrer">
          <Button type="button" secondary size="mini">
            Ver perfil del discípulo
          </Button>
        </a>
      </div>
    )}
    <GuestPlainData guest={guest} onGuestUpdated={onGuestUpdated} />
  </OwnerSection>
);
